// src/components/modalForm/ModalPortal.js
import { cloneElement } from 'react';
import { createPortal } from 'react-dom';
import { useModalStack } from '../../contexts/geral/ModalStackContext';
import { ModalFormContext } from './ModalFormContext';

const ModalPortal = ({ show, children, zIndex = 1050 }) => {
  const modalLayer = useModalStack(show, zIndex);

  if (!show) return null;

  const content = typeof children === 'function'
    ? children(modalLayer)
    : cloneElement(children, {
        style: { ...children.props.style, zIndex: modalLayer.zIndex },
        onKeyDown: (event) => {
          children.props.onKeyDown?.(event);
          event.stopPropagation();
        },
        'data-modal-stack-id': modalLayer.id,
        'aria-modal': modalLayer.isTopModal ? 'true' : undefined,
        inert: modalLayer.isTopModal ? undefined : '',
      });

  return createPortal(<ModalFormContext.Provider value={{ variant: 'legacy' }}>{content}</ModalFormContext.Provider>, document.body);
};

export default ModalPortal;
